import React from "react";

const Instagram = () => (
  <>
    <div className="container">
      <div className="sc-heading style-03">
        <p className="first-title">INSTAGRAM</p>
      </div>
    </div>
    <div className="sc-instagram">
      <div className="container-fluid">
        <div className="row">
          <div className="item">
            <a href="images/home/h-instagram1.jpg" target="_blank">
              <img src="images/home/instagram1.jpg" alt="Chic couple" />
            </a>
          </div>
          <div className="item">
            <a href="images/home/h-instagram2.jpg" target="_blank">
              <img src="images/home/instagram2.jpg" alt="Ariel Sheney à l'hôtel" />
            </a>
          </div>
          <div className="item">
            <a href="images/home/h-instagram3.jpg" target="_blank">
              <img src="images/home/instagram3.jpg" alt="Spécial Martini" />
            </a>
          </div>
          <div className="item">
            <a href="images/home/h-instagram4.jpg" target="_blank">
              <img src="images/home/instagram4.jpg" alt="Jeunes branchées" />
            </a>
          </div>
          <div className="item">
            <a href="images/home/h-instagram5.jpg" target="_blank">
              <img src="images/home/instagram5.jpg" alt="Kaaris à Songon Park" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Instagram;
